var _stop, _stop2, _feOffset, _feGaussianBlur, _feColorMatrix;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import { useUniqueInlineId } from '@inline-svg-unique-id/react';
import * as React from "react";
var SvgBar = function SvgBar(props) {
  var _id3 = useUniqueInlineId();
  var _id2 = useUniqueInlineId();
  var _id = useUniqueInlineId();
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "36px",
    height: "11px",
    viewBox: "0 0 36 11",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "96.313711%",
    y1: "50.3275325%",
    x2: "-2.22044605e-14%",
    y2: "49.7301122%",
    id: _id
  }, _stop || (_stop = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3388FF",
    offset: "0%"
  })), _stop2 || (_stop2 = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8066FF",
    offset: "100%"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M123.5,31 L148.5,31 C149.328427,31 150,31.6715729 150,32.5 L150,34 L150,34 L122,34 L122,32.5 C122,31.6715729 122.671573,31 123.5,31 Z",
    id: _id2
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-25.0%",
    y: "-166.7%",
    width: "150.0%",
    height: "566.7%",
    filterUnits: "objectBoundingBox",
    id: _id3
  }, _feOffset || (_feOffset = /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  })), _feGaussianBlur || (_feGaussianBlur = /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  })), _feColorMatrix || (_feColorMatrix = /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.2   0 0 0 0 0.466666667   0 0 0 0 1  0 0 0 0.276824738 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "bar_svg__\\u6D41\\u7A0B",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "bar_svg__\\u8BC4\\u8BBA",
    transform: "translate(-1223.000000, -96.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "bar_svg__\\u77E9\\u5F62",
    transform: "translate(258.000000, 56.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "bar_svg__\\u77E9\\u5F62",
    transform: "translate(847.000000, 11.000000)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#".concat(_id3, ")"),
    xlinkHref: "#".concat(_id2)
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#".concat(_id, ")"),
    fillRule: "evenodd",
    xlinkHref: "#".concat(_id2)
  }))))));
};
export default SvgBar;